import {gql} from '@apollo/client';

export const FRAGMENT_TOPIC_LIST = gql`
  fragment TopicList on TopicType {
    id
    name
    order
  }
`;
